import React from "react";

interface ImageSectionProps {
  imageUrls: string[];
  maxImages: number;
  isMultipleImages: boolean;
  onRemoveImage?: (index: number) => void;
}

const ImageSection: React.FC<ImageSectionProps> = ({
  imageUrls,
  maxImages,
  isMultipleImages,
  onRemoveImage,
}) => {
  return (
    <div className="flex-1 lg:w-2/3">
      {/* Image Counter Display */}
      <div className="mb-3 text-sm font-medium text-gray-700">
        {isMultipleImages
          ? `Images (${imageUrls.length}/${maxImages})`
          : `Image (${imageUrls.length}/${maxImages})`}
      </div>

      {/* Image Grid */}
      {imageUrls.length > 0 ? (
        <div className="grid grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 gap-3">
          {imageUrls.filter(Boolean).map((url, index) => (
            <div key={index} className="relative group">
              <img
                src={url}
                alt={`Preview ${index + 1}`}
                className="w-full h-32 sm:h-36 lg:h-40 object-cover border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200"
                onError={(e) => {
                  console.error('Failed to load image:', url);
                  e.currentTarget.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIxIDNIMTBMMTAgMTNIMjFWM1oiIGZpbGw9IiNGM0Y0RjYiLz4KPHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyIDJMMTMuMDkgOC4yNkwyMCA5TDEzLjA5IDE1Ljc0TDEyIDIyTDEwLjkxIDE1Ljc0TDQgOUwxMC45MSA4LjI2TDEyIDJaIiBmaWxsPSIjOTQ5NEE0Ii8+Cjwvc3ZnPgo=';
                }}
              />
              {/* Image index indicator */}
              <div className="absolute top-2 left-2 bg-black bg-opacity-50 text-white text-xs px-2 py-1 rounded">
                {index + 1}
              </div>
              {/* Remove button - only show if onRemoveImage is provided */}
              {onRemoveImage && (
                <button
                  onClick={() => onRemoveImage(index)}
                  className="absolute top-2 right-2 bg-red-500 hover:bg-red-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold transition-colors duration-200 shadow-md"
                  title="Remove image"
                >
                  ×
                </button>
              )}
            </div>
          ))}
        </div>
      ) : (
        <div className="w-full h-40 bg-gray-50 border-2 border-dashed border-gray-300 rounded-lg flex items-center justify-center">
          <div className="text-center text-gray-500">
            <svg className="w-12 h-12 mx-auto mb-2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            <p className="text-sm">No images uploaded yet</p>
            <p className="text-xs text-gray-400 mt-1">
              Use the buttons on the right to add images
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageSection;